(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('tmxDuplicate', [tmxDuplicate]);

    function tmxDuplicate() {

        var directive={
            restrict: 'E',
            scope: {
                model: '=',
                onSubmit:"&",
                schema: "=",
                disable: "=",
                columns: "="
            },
        //replace:true,
            templateUrl: 'common/directives/tmxDuplicate/tmxDuplicate-tmp.html',
            controller: ["$scope","$mdDialog","tmxUtility","$q", tmxDuplicateCtrl],
            controllerAs:'tmxDuplicateCtrl'
        };
      
        return directive; 
    }

    function tmxDuplicateCtrl($scope,$mdDialog,tmxUtility,$q){
        var duplicate=this;
        duplicate.scope=$scope;
        duplicate.showDialog=function(){
            showDialog(duplicate,$mdDialog,tmxUtility,$q);
        }
      

    }

    function showDialog(duplicate,$mdDialog,tmxUtility,$q){
        var vm=angular.copy(duplicate.scope.model);
        var sch = angular.copy(duplicate.scope.schema);
        var col = angular.copy(duplicate.scope.columns);
        duplicate.scope.result=vm;
        var dialogParam={
            model:vm, 
            schema:sch,
            columns:col
        };
        $mdDialog.show({
            controller: ["$scope","$mdDialog","params", dialogCtrl],
            controllerAs: "dialogCtrl",
            templateUrl: 'common/directives/tmxDuplicate/tmxDuplicate.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            locals:{params:dialogParam}
        }).then(function(result){
          //function to call saveOrUpdate on replicas
            var calls=[];
            result.forEach(function(resource,index){
                calls.push({
                    key:"resource"+index,
                    promise:resource.$saveOrUpdate()
                });
            });
            tmxUtility.getAsynch($q,calls).then(duplicate.scope.onSubmit);
        });
    }

    function dialogCtrl($scope,$mdDialog,params){
       
        var dialog=this;
        dialog.scope = $scope;
        dialog.scope.model = params.model;
      // dialog.scope.realModel = dialog.scope.model.$getById().then(result);
        var item = dialog.scope.model.$getById().then(function(result) {
            dialog.scope.realModel = result.data;
        });
        dialog.scope.schema = params.schema;
        dialog.scope.columns = params.columns;
        dialog.selectedTab = 0;
        dialog.Data = new kendo.data.ObservableArray([]);
        dialog.Columns = [];
        dialog.fileUploaded = false;
     

        dialog.hide=function(){
            $mdDialog.hide();
        }

        dialog.cancel=function(){
            $mdDialog.cancel();
        }

        dialog.done = function() {
            dialog.Data.splice(0, dialog.Data.length);
        //function to make replicas
            var result = [];
            for (var i = dialog.scope.clone; i > 0; i--) {
                var copy = angular.copy(dialog.scope.realModel);
                for (var key in dialog.scope.schema) {
                    if (dialog.scope.schema.hasOwnProperty(key)) {
                        if(dialog.scope.schema[key].duplicate==false) {
                            copy[key]=undefined;
                        }
                        if(dialog.scope.schema[key].unique==true) {
                            copy[key]+=i;
                        }
                    }
                }
          // dialog.Data.push(copy);
                result.push(copy);
            }
        // dialog.selectedTab = 1;
        // dialog.fileUploaded = true;
        // dialog.Columns = dialog.scope.columns;
        // dialog.Columns.push({ command: ["edit", "destroy"], title: "&nbsp;", width: "210px" });
            $mdDialog.hide(result);
        }

      // dialog.save = function() {
        
      //   $mdDialog.hide(result);
      // }

     //  dialog.mainGridOptions = {
     //            sortable: true,
     //            pageable: true,
                
     //        };

     // dialog.detail = new kendo.data.DataSource({ 
     //  data: dialog.Data,   
     //  pageSize: 10
     //  // editable: "inline",
     //  });

    }
  

})();